// import React from "react";
// import { useLocation } from "react-router-dom";
// import "./invoice.css";

// const InvoicePreview = () => {
//   const { state } = useLocation();
//   const invoice = state?.invoiceData;

//   if (!invoice) return <div>No invoice data found</div>;

//   return (
//     <div className="invoice-container">
//       {/* HEADER */}
//       <div className="invoice-header">
//         <h2>Invoice</h2>
//         <h3>{invoice.property_name || "Hotel / Resort"}</h3>
//         <p>{invoice.property_address}</p>
//         <p>
//           Phone: {invoice.property_phone} | Email: {invoice.property_email}
//         </p>
//       </div>

//       {/* TOP SECTION */}
//       <div className="invoice-top">
//         {/* LEFT BOX */}
//         <div className="left-box">
//           <table>
//             <tbody>
//               <tr>
//                 <td>
//                   <b>Guest Name:</b>
//                 </td>
//                 <td>{invoice.guest_name}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <b>Phone:</b>
//                 </td>
//                 <td>{invoice.guest_phone}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <b>Address:</b>
//                 </td>
//                 <td>{invoice.guest_address}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <b>Check In:</b>
//                 </td>
//                 <td>{invoice.check_in}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <b>Check Out:</b>
//                 </td>
//                 <td>{invoice.check_out}</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>

//         {/* RIGHT BOX */}
//         <div className="right-box">
//           <table>
//             <tbody>
//               <tr>
//                 <td>
//                   <b>Room No:</b>
//                 </td>
//                 <td>{invoice.room_number}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <b>Room Type:</b>
//                 </td>
//                 <td>{invoice.room_type}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <b>Rate:</b>
//                 </td>
//                 <td>{invoice.room_rate}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <b>Nights:</b>
//                 </td>
//                 <td>{invoice.nights}</td>
//               </tr>
//               <tr>
//                 <td>
//                   <b>Status:</b>
//                 </td>
//                 <td>{invoice.payment_status}</td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* MAIN TABLE */}
//       <table className="invoice-table">
//         <thead>
//           <tr>
//             <th>Sr</th>
//             <th>Particular</th>
//             <th>Qty</th>
//             <th>Rate</th>
//             <th>Total</th>
//           </tr>
//         </thead>

//         <tbody>
//           {/* ROOM CHARGES */}
//           <tr>
//             <td>1</td>
//             <td>Room Charges ({invoice.room_type})</td>
//             <td>{invoice.nights}</td>
//             <td>{invoice.room_rate}</td>
//             <td>{invoice.reservation_total}</td>
//           </tr>

//           {/* POS ITEMS */}
//           {invoice.pos_items?.map((item, index) => (
//             <tr key={index}>
//               <td>{index + 2}</td>
//               <td>{item.product}</td>
//               <td>{item.qty}</td>
//               <td>{item.price}</td>
//               <td>{item.total}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* TOTALS BOX */}
//       {/* <div className="totals-box">
//         <table>
//           <tbody>
//             <tr>
//               <td>
//                 <b>Room + POS Total:</b>
//               </td>
//               <td>{invoice.grand_total}</td>
//             </tr>
//             <tr>
//               <td>
//                 <b>Total Paid:</b>
//               </td>
//               <td>{invoice.paid_amount}</td>
//             </tr>
//             <tr>
//               <td>
//                 <b>Balance Due:</b>
//               </td>
//               <td>{invoice.due_amount}</td>
//             </tr>
//           </tbody>
//         </table>
//       </div> */}

//       {/* PAYMENT DETAILS */}
//       <h4 className="payment-title">Payments</h4>
//       <table className="payment-table">
//         <thead>
//           <tr>
//             <th>Date</th>
//             <th>Mode</th>
//             <th>Remarks</th>
//             <th>Amount</th>
//           </tr>
//         </thead>

//         <tbody>
//           {invoice.payment_details?.map((p, i) => (
//             <tr key={i}>
//               <td>{p.created_at?.substring(0, 10)}</td>
//               <td>{p.mode}</td>
//               <td>{p.remarks}</td>
//               {/* <td>{p.payment_method || "Payment"}</td> */}
//               <td>{p.amount}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* FOOTER */}
//       <div className="invoice-footer">
//         <p>Thank you for staying with us!</p>
//       </div>
//     </div>
//   );
// };

// export default InvoicePreview;

import React from "react";
import { Modal, Button, Table, Row, Col } from "react-bootstrap";
import { format, differenceInDays } from "date-fns";
import { useLocation } from "react-router-dom";
import "./invoice.css";

const InvoicePreview = ({ show, onHide, data }) => {
  const reservation = data;
  if (!reservation) return null;
  //   const { state } = useLocation();
  //   console.log(state);
  //   const reservation = state?.invoiceData;
  //   console.log(reservation);
  //   if (!reservation) return null;

  const handlePrint = () => {
    window.print();
  };

  const nights = differenceInDays(
    new Date(reservation.check_out),
    new Date(reservation.check_in)
  );
  const roomRate = reservation.grand_total;
  const taxableAmount = 120;
  const sgstRate = 6;
  const cgstRate = 6;
  const sgstAmount = (taxableAmount * sgstRate) / 100;
  const cgstAmount = (taxableAmount * cgstRate) / 100;
  const totalTax = sgstAmount + cgstAmount;
  const totalPayable = taxableAmount + totalTax;

  // Helper to format currency
  const formatCurrency = (amount) => {
    return amount.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      dialogClassName="invoice-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Invoice View</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invoice-wrapper">
          <div className="invoice-container p-4 border bg-white">
            {/* Header */}
            <div className="invoice-header">
              <div className="invoice-title">Invoice</div>
              <div className="invoice-hotel-name">New</div>
              <div className="text-muted small">GSTIN No: 29AABCU9603R1Z8</div>
              <div className="invoice-address">
                New Hotels & Hospitality Pvt. Ltd. 970, 3rd Cross, 1st Block,
                HRBR Layout, Kalyan Nagar,
                <br />
                Bangalore, Bangalore, Karnataka, 560043, India
              </div>
              <div className="small">
                Phone: 9148787909; E-mail: bookings@newhotels.com; URL:
                www.newhotels.com
              </div>
            </div>

            {/* Details Grid */}
            <div className="invoice-details-grid">
              <div>
                <div>
                  <span className="invoice-label">Folio No. / ResNo</span>:{" "}
                  {reservation.booking_reference_no} / {reservation.id}
                </div>
                <div>
                  <span className="invoice-label">Invoice No</span>:{" "}
                  {reservation.id + 1000}
                </div>
                <div>
                  <span className="invoice-label">Guest Name</span>:{" "}
                  {reservation.guest_name}
                </div>
                <div>
                  <span className="invoice-label">Bill To</span>:{" "}
                  {reservation.guest_name}
                </div>
                <div>
                  <span className="invoice-label">Bill To Address</span>:{" "}
                  {reservation.guest_address || ""}
                </div>
                <div>
                  <span className="invoice-label">State</span>: Karnataka
                </div>
                <div>
                  <span className="invoice-label">Bill To GSTIN No</span>:{" "}
                </div>
                <div>
                  <span className="invoice-label">Source</span>: test
                </div>
                <div>
                  <span className="invoice-label">Source of Supply</span>:
                  Bangalore
                </div>
              </div>
              <div>
                <div>
                  <span className="invoice-label">G.R. Card No</span>:{" "}
                  {reservation.guest_name}
                </div>
                <div>
                  <span className="invoice-label">Date of Invoice</span>:{" "}
                  {format(new Date(), "dd/MM/yyyy HH:mm:ss a")}
                </div>
                <div>
                  <span className="invoice-label">Room</span>:{" "}
                  {reservation.room_number} / {reservation.room_id}
                </div>
                <div>
                  <span className="invoice-label">No of Person</span>: 1 (A) / 0
                  (C)
                </div>
                <div>
                  <span className="invoice-label">Rate Type</span>: Room With
                  Breakfast
                </div>
                <div>
                  <span className="invoice-label">No of Nights</span>: {nights}
                </div>
                <div>
                  <span className="invoice-label">Date of Arrival</span>:{" "}
                  {format(
                    new Date(reservation.check_in),
                    "dd/MM/yyyy HH:mm:ss a"
                  )}
                </div>
                <div>
                  <span className="invoice-label">Date of Departure</span>:{" "}
                  {format(
                    new Date(reservation.check_out),
                    "dd/MM/yyyy HH:mm:ss a"
                  )}
                </div>
              </div>
            </div>

            {/* Items Table */}
            <Table bordered size="sm" className="invoice-table mb-0">
              <thead>
                <tr>
                  <th rowSpan="2" style={{ width: "40px" }}>
                    Sr No
                  </th>
                  <th rowSpan="2">Particular</th>
                  <th rowSpan="2">HSN/SAC</th>
                  <th rowSpan="2">Qty</th>
                  <th rowSpan="2">Rate</th>
                  <th rowSpan="2">Total</th>
                  <th rowSpan="2">Discount</th>
                  <th rowSpan="2">Taxable</th>
                  <th colSpan="2">SGST</th>
                  <th colSpan="2">CGST</th>
                  {/* <th colSpan="2">IGST</th>
                  <th rowSpan="2">CESS</th> */}
                </tr>
                <tr>
                  <th>Rate</th>
                  <th>Amt</th>
                  <th>Rate</th>
                  <th>Amt</th>
                  {/* <th>Rate</th>
                  <th>Amt</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center">1</td>
                  <td>Room Charges</td>
                  <td>996311</td>
                  <td className="text-center">{nights}</td>
                  <td className="text-end">{formatCurrency(roomRate)}</td>
                  <td className="text-end">{formatCurrency(taxableAmount)}</td>
                  <td className="text-end">0.00</td>
                  <td className="text-end">{formatCurrency(taxableAmount)}</td>
                  <td className="text-end">{sgstRate.toFixed(2)}%</td>
                  <td className="text-end">{formatCurrency(sgstAmount)}</td>
                  <td className="text-end">{cgstRate.toFixed(2)}%</td>
                  <td className="text-end">{formatCurrency(cgstAmount)}</td>
                  {/* <td className="text-end">0.00%</td>
                  <td className="text-end">0.00</td>
                  <td className="text-end">0.00</td> */}
                </tr>
                <tr className="fw-bold">
                  <td colSpan="5" className="text-end">
                    Total
                  </td>
                  <td className="text-end">{formatCurrency(taxableAmount)}</td>
                  <td className="text-end">0.00</td>
                  <td className="text-end">{formatCurrency(taxableAmount)}</td>
                  <td></td>
                  <td className="text-end">{formatCurrency(sgstAmount)}</td>
                  <td></td>
                  <td className="text-end">{formatCurrency(cgstAmount)}</td>
                  {/* <td></td>
                  <td className="text-end">0.00</td>
                  <td className="text-end">0.00</td> */}
                </tr>
              </tbody>
            </Table>

            {/* Footer Section */}
            <Row className="mt-0">
              <Col md={6} className="border-end border-bottom border-start p-2">
                <div className="fw-bold mb-2">Total Payable Amount</div>
                <div className="amount-in-words mb-3">
                  {/* Placeholder for number to words */}
                  Two thousand nine hundred and forty only
                </div>

                <Table bordered size="sm" className="invoice-table mb-0">
                  <thead>
                    <tr>
                      <th>Payment Date</th>
                      <th>Description</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {format(new Date(reservation.check_in), "dd/MM/yyyy")}
                      </td>
                      <td>Advance Payment</td>
                      <td className="text-end">
                        {formatCurrency(totalPayable)}
                      </td>
                    </tr>
                    <tr className="fw-bold">
                      <td colSpan="2" className="text-end">
                        Total
                      </td>
                      <td className="text-end">
                        {formatCurrency(totalPayable)}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col md={6} className="p-0">
                <Table
                  bordered
                  size="sm"
                  className="invoice-summary-table mb-0 border-top-0 border-start-0"
                >
                  <tbody>
                    <tr>
                      <td className="text-end fw-bold">Total Charges(Rs) :</td>
                      <td className="text-end" style={{ width: "120px" }}>
                        {formatCurrency(taxableAmount)}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Total Discount(Rs) :</td>
                      <td className="text-end">0.00</td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Total SGST(Rs) :</td>
                      <td className="text-end">{formatCurrency(sgstAmount)}</td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Total CGST(Rs) :</td>
                      <td className="text-end">{formatCurrency(cgstAmount)}</td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Total IGST(Rs) :</td>
                      <td className="text-end">0.00</td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">
                        Total Other Tax(Rs) :
                      </td>
                      <td className="text-end">0.00</td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">
                        Total Balance Transfer(Rs) :
                      </td>
                      <td className="text-end">0.00</td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Total(Rs) :</td>
                      <td className="text-end">
                        {formatCurrency(totalPayable)}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Flat Discount(Rs) :</td>
                      <td className="text-end">0.00</td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Adjustment(Rs) :</td>
                      <td className="text-end">0.00</td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Total Payable(Rs) :</td>
                      <td className="text-end">
                        {formatCurrency(totalPayable)}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Total Payment(Rs) :</td>
                      <td className="text-end">
                        {formatCurrency(totalPayable)}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-end fw-bold">Balance(Rs) :</td>
                      <td className="text-end">0.00</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>

            <div className="mt-3">
              <span className="fw-bold">Remark :</span> {reservation.remarks}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button variant="success" onClick={handlePrint}>
          Print Invoice
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvoicePreview;
